import React from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { SelectOption } from 'types/common'
import classNames from 'classnames'

type Props<T = string> = {
  dataCy?: string
  disabled?: boolean
  hasPlaceholder?: boolean
  index?: number
  onBlur?: () => void
  options: SelectOption[]
  select: (value: T, index?: number) => void
  size?: 'xsmall' | 'small' | 'medium' | 'full'
  value: T | number
}

const SelectBox = <T extends string>(props: Props<T>) => {
  const { dataCy, disabled, hasPlaceholder, index, onBlur, options, select, size = 'full', value } = props
  const dataCyStr = dataCy ? `select-${dataCy}` : 'select'
  return (
    <div
      className={classNames({
        [styles.select__wrapper]: size === 'full',
        [styles.select__wrapper_medium]: size === 'medium',
        [styles.select__wrapper_small]: size === 'small',
        [styles.select__wrapper_xsmall]: size === 'xsmall',
      })}
    >
      <select
        className={classNames(styles.select, {
          [styles.select_xsmall]: size === 'xsmall',
          [text.color_grey_03]: hasPlaceholder && value === '',
        })}
        data-cy={dataCyStr}
        disabled={disabled}
        onBlur={onBlur}
        onChange={(e) => {
          typeof index === 'undefined' ? select(e.target.value as T) : select(e.target.value as T, index)
        }}
        value={value}
      >
        {options.map((option) => (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span
        className={classNames({
          [styles.triangle]: size !== 'xsmall',
          [styles.triangle_xsmall]: size === 'xsmall',
        })}
      />
      <span
        className={classNames({
          [styles.triangle_inverted]: size !== 'xsmall',
          [styles.triangle_inverted_xsmall]: size === 'xsmall',
        })}
      />
    </div>
  )
}

export default SelectBox
